module.exports = __webpack_public_path__ + "img/affirmations.86dba663.png";